import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import {useTestimonials} from "../firebase/useTestimonials";
import {TestimonialCard} from "../testimonials/TestimonialCard";

export const TestimonialsSection = () => {
    const {testimonials} = useTestimonials();
    const publishedTestimonials = (testimonials || []).filter((t) => t.published !== false);

    if (!publishedTestimonials || publishedTestimonials.length === 0) {
        return null;
    }

    return (
        <Box
            component="section"
            id="erfaringer"
            aria-labelledby="erfaringer-title"
            sx={{
                py: {xs: 5, md: 7},
                width: "100%",
                maxWidth: "100%",
            }}
        >
            {/* Section Header */}
            <Box sx={{textAlign: "center", mb: 5, maxWidth: 760, mx: "auto"}}>
                <Box
                    sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 1,
                        bgcolor: "rgba(40, 82, 56, 0.08)",
                        color: "primary.main",
                        px: 2,
                        py: 0.5,
                        borderRadius: 3,
                        mb: 1.5,
                    }}
                >
                    <FormatQuoteIcon sx={{fontSize: 20}} />
                    <Typography variant="caption" sx={{fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase"}}>
                        Erfaringer
                    </Typography>
                </Box>
                <Typography
                    id="erfaringer-title"
                    variant="h4"
                    component="h2"
                    sx={{
                        fontWeight: 800,
                        fontSize: {xs: "1.6rem", sm: "2rem", md: "2.25rem"},
                        color: "primary.main",
                        mb: 1.5,
                    }}
                >
                    Hva fagfolk og kursholdere sier
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        color: "text.secondary",
                        fontSize: {xs: "1rem", sm: "1.1rem"},
                        lineHeight: 1.6,
                    }}
                >
                    Tilbakemeldinger fra helsepersonell og instruktører som bruker kurset i kommunene og i klinisk praksis.
                </Typography>
            </Box>

            {/* Testimonials Layout: Asymmetric 1 + 2 when 3 items, otherwise responsive grid */}
            {publishedTestimonials.length === 3 ? (
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "minmax(0, 1fr)",
                            md: "1.15fr 0.85fr",
                        },
                        gap: 3,
                        alignItems: "stretch",
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: 0,
                    }}
                >
                    {/* Featured detailed story (Left column) */}
                    <Box sx={{display: "flex", height: "100%", minWidth: 0}}>
                        <TestimonialCard testimonial={publishedTestimonials[0]} featured={true} />
                    </Box>

                    {/* Stacked concise quotes (Right column) */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 3,
                            justifyContent: "space-between",
                            minWidth: 0,
                        }}
                    >
                        <Box sx={{display: "flex", flex: 1, minWidth: 0}}>
                            <TestimonialCard testimonial={publishedTestimonials[1]} />
                        </Box>
                        <Box sx={{display: "flex", flex: 1, minWidth: 0}}>
                            <TestimonialCard testimonial={publishedTestimonials[2]} />
                        </Box>
                    </Box>
                </Box>
            ) : (
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "minmax(0, 1fr)",
                            md: publishedTestimonials.length === 2 ? "repeat(2, minmax(0, 1fr))" : "repeat(3, minmax(0, 1fr))",
                        },
                        gap: 3,
                        alignItems: "stretch",
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: 0,
                    }}
                >
                    {publishedTestimonials.map((item) => (
                        <Box key={item.id} sx={{display: "flex", minWidth: 0}}>
                            <TestimonialCard testimonial={item} />
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};
